/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_CITY = `${url}/LOAD_CITY`;
export const LOAD_CITY_SUCCESS = `${url}/LOAD_CITY_SUCCESS`;
export const LOAD_CITY_ERROR = `${url}/LOAD_CITY_ERROR`;

export const LOAD_STATE = `${url}/LOAD_STATE`;
export const LOAD_STATE_SUCCESS = `${url}/LOAD_STATE_SUCCESS`;
export const LOAD_STATE_ERROR = `${url}/LOAD_STATE_ERROR`;

export const LOAD_COUNTRY = `${url}/LOAD_COUNTRY`;
export const LOAD_COUNTRY_SUCCESS = `${url}/LOAD_COUNTRY_SUCCESS`;
export const LOAD_COUNTRY_ERROR = `${url}/LOAD_COUNTRY_ERROR`;

const constants = {
 LOAD_STATE,
 LOAD_STATE_SUCCESS,
 LOAD_STATE_ERROR,
 LOAD_CITY,
 LOAD_CITY_SUCCESS,
 LOAD_CITY_ERROR,
 LOAD_COUNTRY,
 LOAD_COUNTRY_SUCCESS,
 LOAD_COUNTRY_ERROR
};

export default constants;
